import Checkbox from "@/common/elements/InputElements/CheckBox";
import { INPUT_VARIANT } from "@/common/elements/InputElements/const";
import TextField from "@/common/elements/InputElements/TextField";
import { IntakeSectionHeader } from "@/common/styles";
import { forwardRef } from "react";
import { Col, Row } from "antd";
import { FormContainer } from "../InmateDetails/styles";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import CommonDatePicker from "@/common/elements/DatePicker";
import Select from "@/common/elements/InputElements/Select";
import { getOptionsFromRefList } from "@/util/common_function";
import { useSelector } from "react-redux";
import { FieldSecurityProvider } from "@/contexts/FieldSecurityContext";
import SecureFormItem from "@/common/SecureFormItem";
import { SCHEMA_NAME } from "@/util/common_variable";

const ClearanceInformation = ({ changeClearReason, startingPoint = "" }) => {
  const { bookingsFieldsEnabled } = useSelector(
    (state) => state?.bookings
  );
  const fullSearch = useSelector((state) => state.fullSearch);

  return (
    <FieldSecurityProvider
      entity={"Charges"}
      startingPoint={startingPoint}
      bookingsFieldsEnabled={bookingsFieldsEnabled}
    >
      <>
        <IntakeSectionHeader>
          <span>Clearance Information</span>
        </IntakeSectionHeader>

        <FormContainer>
          <Row
            gutter={{
              xs: 8,
              sm: 16,
              md: 24,
              lg: 32,
            }}
          >
            {/* Cleared By */}
            <Col className="gutter-row" span={8}>
              <SecureFormItem
                fieldName="clearedBy"
                formItemProps={{
                  name: "clearedBy",
                  label: "Cleared By",
                  layout: "vertical",
                }}
              >
                <Select
                  options={getOptionsFromRefList("", true, false, true)}
                  placeholder="Cleared By"
                  variant="outlined"
                />
              </SecureFormItem>
            </Col>

            {/* Clearance Date & Time */}
            <Col className="gutter-row" span={8}>
              <SecureFormItem
                fieldName="clearanceDateTime"
                formItemProps={{
                  name: "clearanceDateTime",
                  label: "Clearance Date & Time",
                  layout: "vertical",
                }}
              >
                <CommonDatePicker
                  placeholder="MM/DD/YYYY HH:mm"
                  format="MM/DD/YYYY HH:mm"
                />
              </SecureFormItem>
            </Col>

            {/* Reason */}
            <Col className="gutter-row" span={8}>
              <SecureFormItem
                fieldName="clearanceReasonID"
                formItemProps={{
                  name: "clearanceReasonID",
                  label: "Reason",
                  layout: "vertical",
                  rules: !fullSearch
                    ? [
                        {
                          required: true,
                          message: "Clearance Reason is required",
                        },
                      ]
                    : [],
                }}
              >
                <Select
                  options={getOptionsFromRefList(
                    "ChargeClearance",
                    false,
                    false,
                    true
                  )}
                  placeholder="Cleared Reason"
                  variant="outlined"
                  onChange={changeClearReason}
                />
              </SecureFormItem>
            </Col>
          </Row>
        </FormContainer>
      </>
    </FieldSecurityProvider>
  );
};

export default ClearanceInformation;